import {useState, useContext} from 'react';
import {Form} from 'react-bootstrap';
import {EmailSentNotice} from './EmailSentNotice';
import {LoginContext, LoginScreen} from './LoginContext';
import {PrimaryLogInButton, SignInButtonFlat} from './SignInButton';
import {useTranslateFunction} from 'contexts/translation/TranslationContext';
import {getSignInErrorMessage} from './signInErrors';

export const EmailLinkform = ({
  auth,
  emailHandler,
  title,
  body,
  actionCodeSettings = {},
}) => {
  const [, setLoginState] = useContext(LoginContext);
  const [magicLinkEmail, setMagicLinkEmail] = useState('');
  const [error, setError] = useState('');
  // eslint-disable-next-line @eslint-react/naming-convention/use-state -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
  const [loading, setIsLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const t = useTranslateFunction('miscUI');

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    setIsLoading(false);
    setSent(false);
    try {
      setIsLoading(true);
      await emailHandler(auth, magicLinkEmail, actionCodeSettings);
      setIsLoading(false);
      setSent(true);
    } catch (error) {
      setIsLoading(false);
      setError(getSignInErrorMessage(error, {fallback: 'Error sending email'}));
    }
  };

  return (
    <div className="d-flex flex-column align-items-center">
      {!sent ? (
        <>
          <h2>{t(title)}</h2>
          <p className="mt-2 mb-2 px-2 text-center">{t(body)}</p>
          <Form
            onSubmit={e => {
              handleSubmit(e);
            }}
          >
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Control
                style={{width: 300}}
                type="email"
                placeholder={t('Enter email', {forceString: true})}
                autoComplete="email"
                onChange={e => setMagicLinkEmail(e.target.value)}
                isInvalid={error.length > 0}
                aria-label={t('Enter email', {forceString: true})}
              />
              <Form.Control.Feedback type="invalid">
                {error && t(error)}
              </Form.Control.Feedback>
            </Form.Group>
            <PrimaryLogInButton
              variant="primary"
              type="submit"
              style={{width: '100%'}}
              className="mb-1"
              disabled={loading}
            >
              {loading ? t('Loading…') : t('Send Email')}
            </PrimaryLogInButton>
            <SignInButtonFlat
              variant="light"
              onClick={() => setLoginState(LoginScreen.INIT_LANDING)}
              style={{width: '100%'}}
            >
              {t('Go Back')}
            </SignInButtonFlat>
          </Form>
        </>
      ) : (
        <EmailSentNotice
          emailHandler={emailHandler}
          handlerArgs={[auth, magicLinkEmail, actionCodeSettings]}
        />
      )}
    </div>
  );
};
